// material-ui
import { alpha, Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - BODY ||============================== //

export default function Body(theme: Theme) {
  const thumb = alpha(theme.palette.secondary.main, 0.28);
  const thumbHover = alpha(theme.palette.secondary.main, 0.45);

  return {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFeatureSettings: '"salt"',
          scrollbarWidth: 'thin',
          scrollbarColor: `${thumb} transparent`,
          '&::-webkit-scrollbar': {
            width: 8,
            height: 8
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent'
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: thumb,
            borderRadius: 8
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: thumbHover
          }
        },
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: `${thumb} transparent`
        },
        '*::-webkit-scrollbar': {
          width: 8,
          height: 8
        },
        '*::-webkit-scrollbar-track': {
          background: 'transparent'
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: thumb,
          borderRadius: 8
        },
        '*::-webkit-scrollbar-thumb:hover': {
          backgroundColor: thumbHover
        }
      }
    }
  };
}
